module.exports = __webpack_public_path__ + "img/lead-wechat.cad2ed03.png";